// components/LogoutModal.jsx
import React from 'react';

const LogoutModal = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4">
      {/* Backdrop with whitish blur */}
      <div 
        className="absolute inset-0 bg-white/40 backdrop-blur-md"
        onClick={onClose}
      />
      
      {/* Modal Card */}
      <div className="relative bg-white rounded-2xl border-2 border-primary-blue shadow-2xl w-full max-w-[25rem] 2xl:max-w-md">
        {/* Header with centered title */}
        <div className="relative px-8 pt-6 pb-5">
          <h2 className="text-xl font-semibold text-gray-900 text-center">
            Logout
          </h2>
          <button
            onClick={onClose}
            className="absolute right-6 top-6 hover:opacity-70 transition-opacity"
          >
            <svg className="w-6 h-6" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#9CA3AF" strokeWidth="2" fill="none"/>
              <path d="M8 8L16 16M16 8L8 16" stroke="#9CA3AF" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Icon and Message */}
        <div className="px-8 pb-6 pt-2 flex flex-col items-center">
          {/* Logout Icon */}
          <div className="mb-4">
            <img
              src="/Icons/logout-modal-icon.svg"
              alt="Logout"
              className="w-20 h-20"
            />
          </div>
          
          {/* Confirmation Message */}
          <p className="text-center text-gray-700 text-base">
            Are you sure you want to log out of your account now?
          </p>
        </div>

        {/* Action Buttons */}
        <div className="px-8 pb-6 pt-2 flex gap-3">
          <button
            onClick={onConfirm}
            className="flex-1 py-3 bg-primary-blue text-white font-semibold rounded-lg hover:bg-blue-500 transition-colors text-base"
          >
            Logout
          </button>
          <button
            onClick={onClose}
            className="flex-1 py-3 bg-white border-2 border-primary-blue text-primary-blue font-semibold rounded-lg hover:bg-primary-blue transition-colors text-base  hover:text-white"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
